export const SET_LOCALE = 'SET_LOCALE'
export const SAVE_LOCALE = 'SAVE_LOCALE'
export const TOGGLE_THEME = 'TOGGLE_THEME'
export const SET_PROJECTS = 'SET_PROJECTS'
export const SET_PROJECT_DETAILS = 'SET_PROJECT_DETAILS'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const SET_CURRENT_PROJECT = 'SET_CURRENT_PROJECT'
export const SET_FILTERS = 'SET_FILTERS'
export const SET_ACTIVE_FILTER = 'SET_ACTIVE_FILTER'
export const TOGGLE_MENU = 'TOGGLE_MENU'
export const SET_REFERRAL = 'SET_REFERRAL'
export const TOGGLE_LOADING = 'TOGGLE_LOADING'
export const SET_TEAM = 'SET_TEAM'
export const SET_JOBS = 'SET_JOBS'
export const SET_JOB_DESCRIPTION = 'SET_JOB_DESCRIPTION'
export const SET_CUSTOMERS1 = 'SET_CUSTOMERS1'
export const SET_CUSTOMERS2 = 'SET_CUSTOMERS2'
export const SET_NEWS = 'SET_NEWS'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js